
import {REQUESTED_REQUEST, REQUESTED_SUCCESS,REQUESTED_FAIL} from "../constants/AuthConstant";

const axios = require("axios");
export const RequestAction = (data) => {
    return function (dispatch) {
      dispatch({
        type: REQUESTED_REQUEST,
        payload: true,
      });
      let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/get_user_requested_profile_by_vendorId?vendorId=${data?.vendorId}&pageNumber=${data.pageNumber}&pageSize=10`,
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      };
      axios(OPTION)
        .then((res) => {
          dispatch(RequestPre(res.data));
        })
        .catch((error) => {
          dispatch({
            type: REQUESTED_FAIL,
            payload: false,
            error: error,
            msg: "Failed to load the information",
          });
        });
    };
  };
  export const RequestPre = (data) => {
    return {
      type: REQUESTED_SUCCESS,
      result: data,
      payload: false,
      msg: "SUCCESS",
    };
  };
  